<template>
  <section class="introduction">
    <div class="titleAndRichTextContent container--Medium">
      <h2 class="titleAndRichTextContent__Title" v-text="data.title" />
      <div class="titleAndRichTextContent__Texts" v-html="data.description" />
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_introduction.scss');
</style>